import { atom } from 'jotai';

export const unreadMailThreadsNumberAtom = atom<number>(0);
